/**
 * Executive KPI report snapshots for Reporting Center (ExecReport).
 */

import { executiveApiService } from './executiveApiService';
import { executiveDashboardService } from './executiveDashboardService';

/** Strip heavy operational source blob before persisting. */
export function slimExecutivePayload(data) {
  if (!data || typeof data !== 'object') return {};
  const { source, tileCatalog, ...rest } = data;
  return rest;
}

export const executiveReportService = {
  async generateReport({ organizationId, organizationName, period, compareTo } = {}) {
    const data = await executiveDashboardService.getExecutiveDashboardData({
      organizationId,
      organizationName,
      period,
      compareTo,
    });
    return data;
  },

  buildSaveBody(reportData, { name, notes, period, compareTo } = {}) {
    return {
      name: name?.trim() || `Executive KPI — ${new Date().toLocaleDateString()}`,
      report_period: period || reportData?.period || null,
      compare_to: compareTo || reportData?.compareTo || null,
      notes: notes?.trim() || null,
      payload: slimExecutivePayload(reportData),
    };
  },

  async saveReport(organizationId, reportData, meta) {
    const body = this.buildSaveBody(reportData, meta);
    return executiveApiService.saveReport(organizationId, body);
  },

  async listSavedReports(organizationId) {
    const data = await executiveApiService.listReports(organizationId);
    return data?.items || [];
  },

  async loadSavedReport(organizationId, reportId) {
    return executiveApiService.getReport(organizationId, reportId);
  },

  async deleteSavedReport(organizationId, reportId) {
    return executiveApiService.deleteReport(organizationId, reportId);
  },

  async compareSavedReports(organizationId, baselineReportId, comparisonReportId) {
    return executiveApiService.compareReports(organizationId, {
      baselineReportId,
      comparisonReportId,
    });
  },

  downloadReportJson(reportDoc, filename) {
    const blob = new Blob([JSON.stringify(reportDoc, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `executive-kpi-report-${Date.now()}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
